var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.591 29.816 8.77 24.995a.567.567 0 0 1-.074-.086l-.005-.008v-.021l-.006-.01-.006-.011a.566.566 0 0 1 .1-.658l4.832-4.832a.566.566 0 0 1 .8 0 .567.567 0 0 1 0 .8l-3.865 3.865h11.517a.566.566 0 0 1 .566.566.566.566 0 0 1-.566.567H10.546l3.865 3.865a.565.565 0 0 1 0 .8.563.563 0 0 1-.4.166.562.562 0 0 1-.42-.182Z",
    "data-name": "Path 5993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back-arrow-icon.8a26e3ebc98679c77687e1e9e7ae1099.svg";
export { ForwardRef as ReactComponent };